import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import Map from '@arcgis/core/Map';
import MapView from '@arcgis/core/views/MapView';
import WebMap from '@arcgis/core/WebMap';
import BasemapToggle from '@arcgis/core/widgets/BasemapToggle';
import Expand from '@arcgis/core/widgets/Expand';
import Home from '@arcgis/core/widgets/Home';
import LayerList from '@arcgis/core/widgets/LayerList';
import Search from '@arcgis/core/widgets/Search';
import { useEffect, useState } from 'react';
import { layerExtent } from '../arcgis/jsapi/js-api-util';

// Map widget state.
const useMapWidgets = ({
    appConfig,
    map,
    view,
    layer,
    nameField
}: {
    appConfig: any;
    map: Map | WebMap | undefined;
    view: MapView | undefined;
    layer: FeatureLayer;
    nameField: string;
}): any => {
    const [widgets, setWidgets] = useState<any>();

    // Build widgets once map is ready.
    useEffect(() => {
        if (
            appConfig !== undefined &&
            view !== undefined &&
            view.ui !== undefined &&
            view.ui !== null &&
            map !== undefined
        ) {
            const oWidgets: any = {};

            const home = new Home({ view });
            view.ui.add(home, { position: 'top-left' });
            oWidgets.home = home;

            const basemapToggle = new BasemapToggle({ view });
            view.ui.add(basemapToggle, { position: 'bottom-left' });

            if (appConfig.displayLegendTool === true) {
                const layerList = new LayerList({
                    view,
                    listItemCreatedFunction: (event: any) => {
                        if (event.item.layer.type !== 'group')
                            event.item.panel = {
                                content: 'legend',
                                open: true
                            };
                    }
                });
                const layerListExpand = new Expand({
                    view,
                    content: layerList
                });
                view.ui.add(layerListExpand, { position: 'top-left' });
            }

            const search = new Search({
                view,
                includeDefaultSources: false
            });
            view.ui.add(search, { position: 'bottom-right' });
            oWidgets.search = search;

            setWidgets(oWidgets);
        }
    }, [appConfig, map, view]);

    // Update widgets when the selected layer or search field change.
    useEffect(() => {
        if (
            view !== undefined &&
            layer !== undefined &&
            widgets !== undefined
        ) {
            const updateWidgets = async () => {
                const response = await layerExtent({ layer, view });
                if (widgets.home !== undefined)
                    widgets.home.viewpoint = { target: response.extent };

                if (widgets.search !== undefined && nameField !== undefined) {
                    widgets.search.allPlaceholder = `Find ${layer.title} or Place`;
                    widgets.search.sources = [
                        {
                            layer,
                            searchFields: [nameField],
                            exactMatch: false,
                            name: layer.title,
                            placeholder: `Find ${layer.title}`,
                            suggestionTemplate: `{${nameField}}`
                        }
                    ];
                    if (
                        appConfig.locatorServiceUrl !== undefined &&
                        appConfig.locatorServiceUrl !== ''
                    )
                        widgets.search.sources = [
                            ...widgets.search.sources,
                            {
                                url: appConfig.locatorServiceUrl,
                                exactMatch: false,
                                name: 'Address or Place',
                                placeholder: 'Address or Place',
                                filter: { geometry: response.extent }
                            }
                        ];
                }
            };
            updateWidgets();
        }
    }, [appConfig, layer, nameField, view, widgets]);
    return widgets;
};
export default useMapWidgets;
